import React from 'react';
import Utils from 'common/utils'
import Constants from 'common/constants'
import NativeAgent from 'common/nativeAgent'
import RemoteLogger from 'common/remoteLogger'
import RefreshDataState from 'models/refreshDataState'

const KEY_BOTTOM_BAR = "set_bottom_bar"

export default class CommonComponents {
    static getBottomBarComponents() {
        var shouldSetBottomBar = this.shouldSetBottomBar();
        console.log("Should set bottom bar - " + shouldSetBottomBar)
        if (shouldSetBottomBar === false || !Utils.isWebView()) {
            return <span></span>
        }
        return <div className="bottom-bar-sw-keys"></div>
    }

    static shouldSetBottomBar() {
        var shouldSetBottomBar = Constants.DEFAULT_SET_BOTTOM_BAR;
        var shouldSetBottomBarStr = Utils.getValForKeyFromCurrentUrl(KEY_BOTTOM_BAR)
        if (false === Utils.isNull(shouldSetBottomBarStr)) {
            shouldSetBottomBar = (shouldSetBottomBarStr === "1")
        }
        
        return shouldSetBottomBar;
    }

    static getWeatherTopBarComponent() {
        if (Utils.isWebView())  {
           return <div className="weather-top-bar"></div>
        } else {
            return <span></span>
        }

    }

    static AddWindowRefreshHandler(handler) {
        window.WeatherRefreshHandler = handler
    }

    // Default handler that perform page refresh
    static DefaultRefreshHandler() {
        var state = new RefreshDataState(
            true,
            false,
            false,
            ""
        )
        console.log("REFRESH: Handling refresh using default handler")

        try {
            var refreshJSONStr = JSON.stringify(state)
            console.log("REFRESH: Sending data to native-agent -", refreshJSONStr)
            NativeAgent.updateRefreshManagerStatus(refreshJSONStr)
        } catch (e) {
            RemoteLogger.log(e)
        }

        setTimeout(() => {
            window.location.reload(true)
        }, 200)
    }
}


// WEBPACK FOOTER //
// ./src/components/commonComponents.js